import { createRouter, createWebHistory } from "vue-router";
import AboutView from "./views/AboutView.vue";
import CidrPlannerView from "./views/CidrPlannerView.vue";
import DataWorkbenchView from "./views/DataWorkbenchView.vue";
import DirectoryView from "./views/DirectoryView.vue";
import EntryView from "./views/EntryView.vue";
import HomeView from "./views/HomeView.vue";
import LibraryView from "./views/LibraryView.vue";
import EnglishView from "./views/EnglishView.vue";
import { applySeo, routeSeo } from "./lib/seo";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior: (to) => to.hash ? { el: to.hash, top: 88 } : { top: 0 },
  routes: [
    { path: "/", name: "home", component: HomeView },
    { path: "/library", name: "library", component: LibraryView },
    { path: "/tools", name: "tools", component: DirectoryView },
    { path: "/tools/cidr", name: "cidr-planner", component: CidrPlannerView },
    { path: "/tools/json-yaml", name: "data-workbench", component: DataWorkbenchView },
    { path: "/tools/time", name: "time-converter", component: () => import("./views/TimeConverterView.vue") },
    { path: "/directory", redirect: "/tools" },
    { path: "/entry/:id", name: "entry", component: EntryView },
    { path: "/about", name: "about", component: AboutView },
    { path: "/en/", name: "en-home", component: EnglishView },
    { path: "/en/library", name: "en-library", component: EnglishView },
    { path: "/en/tools", name: "en-tools", component: EnglishView },
    { path: "/en/about", name: "en-about", component: EnglishView },
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
});

router.beforeEach((to) => {
  if (to.path === "/library" && to.query.section === "airports") {
    return { name: "library", query: { section: "knowledge", status: "published" }, replace: true };
  }
});

router.afterEach((to) => {
  applySeo(routeSeo(to));
  window.gtag?.("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href,
    page_path: to.fullPath,
  });
});

export default router;
